import { Pipe, PipeTransform } from '@angular/core';
import { Invoice, INVOICE_STATUS_GROUP_MAP, INVOICE_STATUS_GROUP_TO_COLOR } from '../../domains/invoices';

@Pipe({ name: 'invoiceStatusColor' })
export class InvoiceStatusColorPipe implements PipeTransform {
  transform(invoice: Invoice): string {
    return INVOICE_STATUS_GROUP_TO_COLOR[INVOICE_STATUS_GROUP_MAP[invoice?.status]] ?? 'dark';
  }
}
